module.exports = __webpack_public_path__ + "static/media/HomeRoll_Roof_ColorBondRoof.f507228e.jpg";